import { createContext } from 'react';

export type SidePanelColumnState = {
  /** The only `SidePanel` the column shows, matched on `columnPanelId`. */
  activePanelId: string | null;
  /** When false, panels open and close without a transition. */
  isAnimated: boolean;
};

/** Outside a column, `SidePanel`s are unrestricted and animated. */
export const SidePanelColumnContext =
  createContext<SidePanelColumnState | null>(null);
